import { PropsWithChildren } from 'react';

type MenuProps = PropsWithChildren;

export const Menu = ({ children }: MenuProps)=> {
    return (
        <nav
            className={'fixed bottom-0 left-0 h-24 z-40 w-full px-4 pb-2 md:h-screen md:w-28 md:pr-0 md:py-4 lg:w-64'}>
            <div
                className={'flex h-full w-full flex-row justify-around items-center gap-4 bg-surface-1/70 backdrop-blur-sm shadow-lg p-2 rounded-2xl md:flex-col md:items-center md:justify-start md:py-4 lg:gap-2 md:shadow-none md:bg-surface-1 lg:px-4 lg:pt-8'}>
                {children}
            </div>
        </nav>
    );
}
